export const INIT_SEASON_DATA = "INIT_SEASON_DATA";
export const INIT_SEASON_DATA_COMPLETE = "INIT_SEASON_DATA_COMPLETE";
export const SAVE_DEFAULT_GAME_CONFIGURATION =
	"SAVE_DEFAULT_GAME_CONFIGURATION";
export const SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE =
	"SAVE_DEFAULT_GAME_CONFIGURATION_COMPLETE";
export const GET_SEASONS = "GET_SEASONS";
export const GET_SEASONS_COMPLETE = "GET_SEASONS_COMPLETE";
export const SET_CURRENT_SEASON = "SET_CURRENT_SEASON";
export const SET_CURRENT_SEASON_COMPLETE = "SET_CURRENT_SEASON_COMPLETE";
export const GET_CURRENT_SEASON = "GET_CURRENT_SEASON";
export const GET_CURRENT_SEASON_COMPLETE = "GET_CURRENT_SEASON_COMPLETE";
export const RESTORE_DEFAULT_GAME_CONFIGURATION =
	"RESTORE_DEFAULT_GAME_CONFIGURATION";
export const RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE =
	"RESTORE_DEFAULT_GAME_CONFIGURATION_COMPLETE";
export const RESET_CURRENT_SEASON = "RESET_CURRENT_SEASON";
export const SET_SEASON_CONFIGURATION = "SET_SEASON_CONFIGURATION";
export const SET_SEASON_CONFIGURATION_COMPLETE =
	"SET_SEASON_CONFIGURATION_COMPLETE";
export const SET_RULE_SET_ID_COMPLETE = "SET_RULE_SET_ID_COMPLETE";
